var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.mounted ? 'swiper-slide' : 'div',{tag:"component",staticClass:"ab-slider-item",class:{ 'ab-slider-item--ssr': !_setup.loaded }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }